module.exports = __webpack_public_path__ + "img/CS.2a218c86.png";